export const Regex = {
	Phone: /^(?:\+\d{1,3}\d{9}|\d{10})$/,
	PostalCode: /^\d{4}$/,
	/**
	 * - `\p{L}`: Matches any kind of letter from any language.
	 * - `0-9`: Matches digits.
	 * - `\s`: Matches whitespace characters.
	 * - `\-`: Matches the literal hyphen `-`.
	 * - `*`: Allows zero or more of the preceding characters.
	 * - `u` flag: Enables Unicode mode, which is necessary for `\p{...}`
	 */
	NoSpecialCharacters: /^[\p{L}0-9\s\-]*$/u,
	Alphanumeric: /^[a-zA-Z0-9]+$/,
}
